export default __webpack_public_path__ + "static/media/covid8.a94bc38d.jpg";